<template>
  <section class="top">
    <BlogBreadcrumbs class="top__breadcrumbs" />
    <h1 class="top__title">
      {{ title }}
    </h1>
    <LazyBlogPostInfo
      v-if="authors.length > 0"
      :authors="authors"
      :date="new Date(rawDate)"
    />
  </section>
</template>

<script lang="ts" setup>
import type { BlogAuthorStoryblok, Story } from '@/types'

interface Props {
  title?: string
  authors: Story<BlogAuthorStoryblok>[]
  date: Date | null
  rawDate: string
}

defineProps<Props>()
</script>

<style lang="scss" scoped>
.top {
  &__title {
    padding-bottom: 24px;
    margin-bottom: 24px;
    border-bottom: 1px solid var(--gray-300);
    font-weight: 600;
  }

  &__breadcrumbs {
    margin-bottom: 56px;
  }
}
</style>
